import React from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { FaRegCopy } from "react-icons/fa6";

const SectionTwo = () => {
  const { singleSelected } = useSelector((state) => state.file);
  const copyText = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Copied!");
      })
      .catch(() => {
        toast.error("Try again!");
      });
  };

  return (
    <div className="w-full lg:w-[300px] mt-5 lg:mt-0 border drop-shadow-md bg-white rounded-lg p-5 space-y-5">
      <div className="w-full h-full rounded-lg overflow-hidden">
        <img
          className="w-full h-full object-cover"
          src={singleSelected.fileLink.medium}
          alt=""
        />
      </div>
      <div className="">
        <p className="text-sm text-black/50 break-all">
          {singleSelected.fileName}
        </p>
      </div>
      <div className="flex gap-x-2">
        <input
          type="text"
          value={singleSelected.fileLink.original}
          className="text-black bg-gray-100 w-full text-xs px-2 py-2 rounded-lg"
          disabled
        />
        <button
          className="bg-blue-100 w-7 h-7 flex justify-center items-center rounded-full scale-100 hover:scale-110 duration-300"
          onClick={() => copyText(singleSelected.fileLink.original)}
        >
          <FaRegCopy />
        </button>
      </div>
      <div className="space-y-3">
        <div>
          <p className="text-xs text-black/60">
            <strong>Size:</strong>{" "}
            {(singleSelected.size / (1024 * 1024)).toFixed(2)} MB
          </p>
        </div>
        <div className="flex justify-start items-center gap-x-2">
          <p className="text-xs text-black/60">
            <strong>Width:</strong> {singleSelected.width}px
          </p>
          <p className="text-xs text-black/60">
            <strong>Height:</strong> {singleSelected.height}px
          </p>
        </div>
      </div>
    </div>
  );
};

export default SectionTwo;
